import { findCustomProvider } from './customProviders'

const HTTPS_URL = /^https:\/\/[^\s/]+\.[^\s]+$/
const article = (word) => (/^[AEIOU]/i.test(word) ? 'an' : 'a')

function keyError(draft, saved, provider) {
  const key = draft.apiKey.trim()
  // Leaving the field blank keeps the saved key, but only for the same provider.
  if (!key) return saved?.keyHint && saved.provider === draft.provider ? null : 'Enter your API key'
  if (provider.keyPattern.test(key)) return null
  return `This doesn’t look like ${article(provider.label)} ${provider.label} key. ${provider.keyHint}.`
}

/** Field → message for everything wrong with the draft; `{}` when it can be saved. */
export function validateCustomModel(draft, saved) {
  const provider = findCustomProvider(draft.provider)
  if (!provider) return { provider: 'Choose a provider' }
  const errors = {}
  if (!draft.model.trim()) errors.model = `Enter a ${(provider.modelLabel ?? 'model').toLowerCase()}`
  const apiKey = keyError(draft, saved, provider)
  if (apiKey) errors.apiKey = apiKey
  if (provider.baseUrlPlaceholder && !HTTPS_URL.test(draft.baseUrl.trim())) {
    errors.baseUrl = 'Enter the endpoint URL, starting with https://'
  }
  return errors
}
